import React from 'react'

export type BreadcrumbContext = {
  currentPath: string
  labelName: string
  newLabel: string
  indexDuplicated: number | null
  indexToRemove: number | null
  currentIndex: number
  items: BreadcrumbItem
}

export type BreadcrumbItem = {
  index: number
  path: string
  label: string
  next?: BreadcrumbItem | null
  previous?: BreadcrumbItem | null
}

export const breadcrumbContext: BreadcrumbContext = {
  currentIndex: 0,
  currentPath: '',
  indexDuplicated: null,
  indexToRemove: null,
  items: { index: 0, label: 'Home', path: '/' },
  labelName: '',
  newLabel: '',
}

export const DataBreadcrumb = React.createContext(breadcrumbContext)
